module.exports = __webpack_public_path__ + "static/img/iOS_yxz.250291a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/iOS_yxz.png
// module id = NevU
// module chunks = 2